
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import { ClientsCategoriesRequestType } from "./clients.types";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";

@Component
export default class ClientsCategoriesForm extends Form {

    @Validate(required, i18nText("Введите назавание категории"))
    name: string | null = null;
    color: string | null = null;
    icon: string | null = null;

    getFormData(): ClientsCategoriesRequestType {
       return{
            name: this.name,
            color: this.color,
            icon: this.icon,
       } 
    }

    setFormData(data: Record<string, any>): void {
        this.name = data.name
        this.color = data.color
    }
}
